import { render, staticRenderFns } from "./InputOneCheckbox.vue?vue&type=template&id=07be412b"
import script from "./InputOneCheckbox.vue?vue&type=script&lang=js"
export * from "./InputOneCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports